import { atom } from 'jotai';
import { store } from '@/state/store';

export type InboxFilterState = {
  messagesPerPage: number;
};

const initialState: InboxFilterState = {
  messagesPerPage: 10,
};

export const inboxFilterState = atom<InboxFilterState>(initialState);

export const messagesPerPage = atom(
  (get) => get(inboxFilterState).messagesPerPage,
);

export function setInboxFilterState(state: InboxFilterState): void {
  store.set(inboxFilterState, state);
}

export function setMessagesPerPage(messagesPerPage: number): void {
  setInboxFilterState({ messagesPerPage });
}

export default inboxFilterState;
